/**
 * Feet collision box shared by every map actor: 20 × 12 px below the sprite origin (0.5, 1), spanning
 * `x-10 … x+9` horizontally and `y-12 … y-1` vertically (pure; unit-tested).
 */
export const FEET_BOX = { w: 20, h: 12 } as const;

/**
 * True when the feet boxes of two actors whose feet points are (ax, ay) and (bx, by) overlap.
 * Intended for an `ActorOptions.isActorBlocked` query (actor–actor blocking), e.g.
 * `isActorBlocked: (self, x, y) => npcs.some((n) => n !== self && feetOverlap(x, y, n.fx, n.fy))`.
 */
export function feetOverlap(ax: number, ay: number, bx: number, by: number, box: { w: number; h: number } = FEET_BOX): boolean {
  return Math.abs(ax - bx) < box.w && Math.abs(ay - by) < box.h;
}
